import { BillingRefreshNotice } from './billing-refresh-notice'
import { SubscriptionDialogModal } from './subscription-dialog'
import type { SelectableV2Plan } from './plan-select-cards'
import { TopUpPaywall } from './top-up-paywall'
import type { TopUpKindSpec } from './top-up-kinds'
import { useTopUp } from './use-top-up-actions'

export interface TopUpModalProps {
  spec: TopUpKindSpec
  tier: SelectableV2Plan
  /** The surface that opened it, for the Paywall analytics events. */
  from: string
  /** Whether the allowance this top-up refills is spent. */
  atLimit: boolean
  onClose: () => void
}

/**
 * A top-up paywall as a centered modal, closing itself once a purchase
 * commits. Mount it only while open, keyed per kind where the kind can change,
 * so the slider resets between openings and a settled purchase can't hold a
 * stale latch.
 */
export function TopUpModal({ spec, tier, from, atLimit, onClose }: TopUpModalProps) {
  const { onPurchase, onUpgrade, isPending, isUpgradePending, errorMessage, needsBillingRefresh } = useTopUp(spec, {
    tier,
    from,
    onPurchased: onClose,
  })

  return (
    <SubscriptionDialogModal open onOpenChange={(next) => !next && onClose()}>
      {needsBillingRefresh ? (
        <BillingRefreshNotice onRefreshed={onClose} />
      ) : (
        <TopUpPaywall
          spec={spec}
          plan={tier}
          atLimit={atLimit}
          brandMark
          onPurchase={onPurchase}
          onUpgrade={onUpgrade}
          isPending={isPending}
          isUpgradePending={isUpgradePending}
          errorMessage={errorMessage}
        />
      )}
    </SubscriptionDialogModal>
  )
}
